import React from 'react'

const Education = () => {
  return (
    <section className="resume-area page-section scroll-to-page" id="resume">
    <div className="custom-container">
      <div className="resume-content content-width">
        <div className="section-header">
          <h4 className="subtitle scroll-animation" data-animation="fade_from_bottom">
            <i className="las la-briefcase" /> My journey
          </h4>
          <h1 className="scroll-animation" data-animation="fade_from_bottom">Education &amp; <span>Experience</span></h1>
        </div>
        <div className="resume-timeline">
          <div className="item scroll-animation" data-animation="fade_from_right">
            <span className="date">2021</span>
            <h2>Complete Diploma</h2>
            <p>Learn HTML,CSS,JAVASCRIPT,BOOTSTRAP,JQUERY<br/>,PHP and MYSQL</p>
            {/* <h2>Front-End WordPress Developer</h2>
            <p>Envato Market</p> */}
          </div>
          <div className="item scroll-animation" data-animation="fade_from_right">
            <span className="date">2022</span>
            <h2>Learn By Myself</h2>
            <p>Learn React.js ,Node.js ,Express.js and Mongodb(MERN STACK)</p>
            <h2>Hired By StackerBee Company </h2>
            <p>As a FullStack Developer</p>
            <h2>Complete Ayurherbals Ecommerce Project </h2>
            <p>Use REACT.JS,CODEIGNITER,MYSQL,HTML,<br/>CSS,BOOTSTRAP,JAVASCRIPT,JQUERY</p>
            <p>Link :<a href="https://www.ayurherbals.co/" target="_blank" style={{color:"rgb(0, 105, 62)"}} rel="noopener noreferrer"> https://www.ayurherbals.co/</a></p>
            <p>Integrated Ccavenue Payment Geteway</p>
            <p>Integrated Smartship Shipping API</p>
            <p>Integrated PHP API in REACT.JS</p>
            <p>Create API in PHP(CODEIGNITER)</p>
            <p>Experience Many Other Featured</p>
            
          </div>
          <div className="item scroll-animation" data-animation="fade_from_right">
            <span className="date">2023</span>


            <h2>Learn Some Awesome Feature </h2>
            <p>FlipBook 1 :<a href="https://kitchenandwardrobebrochure.netlify.app/" target="_blank" style={{color:"rgb(0, 105, 62)"}} rel="noopener noreferrer"> https://kitchenandwardrobebrochure.netlify.app/</a></p>
            <p>FlipBook 2: <a href="https://architecturalhardwarebrochure.netlify.app/" target="_blank" style={{color:"rgb(0, 105, 62)"}} rel="noopener noreferrer">https://architecturalhardwarebrochure.netlify.app/</a></p>
            <p>Flipbooks in Hardwyn Link : <a href="https://www.hardwyn.com/" target="_blank" style={{color:'rgb(0, 105, 62)'}} rel="noopener noreferrer">https://www.hardwyn.com/</a></p>
            <p>Learn Genrate Barcode of Web Pages</p>
            <p>Learn Shiprocket Shipping API Integration</p>

            <h2>Complete KycFirst Project</h2>
            <p>USING REACT.JS,BOOTSTRAP,PYTHON,MYSQL</p>
            <p>Link : <a href="https://www.kycfirst.io/" target="_blank" style={{color:"rgb(0, 105, 62)"}} rel="noopener noreferrer">https://www.kycfirst.io/</a></p>
            <p>Integrated Biometric Fingerprint Scanner</p>
            <p>Integrated Verify Document API's</p>
            <p>Worked on Wallet and Subscription Plan Featured</p>
            <p>Handle Complete REACT.JS(Frontend)</p>
            <p>Experience Many Other Featured</p>
            <p>Integrated PYTHON API in REACT.JS</p>
            <h2>Create Portfolio Project</h2> 
            <p>USING REACT.JS,NODE.JS,EXPRESS.JS<br/>,MONGODB (MERN STACK PROJECT)</p>
            <p>Link : <a href="https://webmasteryazy.netlify.app/" target="_blank" style={{color:"rgb(0, 105, 62)"}} rel="noopener noreferrer">https://webmasteryazy.netlify.app/</a></p>
            <p>Integrated NODE.JS API in REACT.JS</p>
            <p>Create API in NODE.JS</p>
            <h2>Working on Oneupbrands Project</h2>
            <p>USING REACT.JS,PYTHON,MYSQL</p>
            <p>Link : <a href="https://oneup.stackerbee.com/" target="_blank" style={{color:"rgb(0, 105, 62)"}} rel="noopener noreferrer"> https://oneup.stackerbee.com/</a></p>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Education